export default "__VITE_ASSET__D5ZCUh7m__"